import { render, staticRenderFns } from "./DebugPackageForm.vue?vue&type=template&id=482b3a2c&scoped=true"
import script from "./DebugPackageForm.vue?vue&type=script&lang=js"
export * from "./DebugPackageForm.vue?vue&type=script&lang=js"
import style0 from "./DebugPackageForm.vue?vue&type=style&index=0&id=482b3a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b3a2c",
  null
  
)

export default component.exports